export default __webpack_public_path__ + "static/27-486026bf9391a375c00dec16b8b3cd60.jpg";